<template>
  <div>
    <div :class="['row']">
      <div class="img-container">
        <!-- <img class="logo" sc="../../assets/logo_allfood_escrita_branca.png" alt=""> -->
        <img class="logo" :src="logo" alt="" />
      </div>

      <!-- caso nao seja delivery, mostrar estes botoes  -->
      <div
        class="preco"
        v-if="this.$store.state.tipoCardapio !== 'delivery'"
      >
        <router-link
          v-if="
            !this.$store.state.isMenuEstatico &&
            this.$store.state.motivosChamarGarcom.length > 0
          "
          class="icone-texto"
          :to="{ name: 'garcom' }"
        >
          <img
            :style="{ filter: corImagem }"
            src="../../assets/icons/ic-waiter.svg"
            alt=""
            class="ic-carrinho"
          />
          <h4 class="texto-menu-top">CHAMAR<br />O GARÇOM</h4>
        </router-link>

        <router-link
          v-if="!this.$store.state.isMenuEstatico"
          class="icone-texto"
          :to="{ name: 'conta' }"
          style=""
          :is="podeVerConta ? 'span' : 'router-link'"
          @click="alertarVerConta()"
        >
          <img
            :style="{ filter: corImagem }"
            src="../../assets/icons/ic-wallet.svg"
            alt=""
            :class="['ic-carrinho']"
          />
          <h4 class="texto-menu-top">
            CONTA DA<br />{{ mesaOuCartao }} {{ numeroMesa }}
          </h4>
        </router-link>

        <!-- apenas para menu estatico -->
        <div
          v-if="this.$store.state.isMenuEstatico"
          class="menu-estatico-container texto-menu-top"
        >
          <h4>Menu online</h4>
        </div>
      </div>

      <!-- caso seja delivery, mostrar isso  -->
      <div class="preco" v-if="this.$store.state.tipoCardapio === 'delivery'">
        <router-link class="icone-texto" :to="{ name: 'statusdelivery' }">
          <img
            :style="{ filter: corImagem }"
            src="../../assets/icons/ic_meus_pedidos.png"
            alt=""
            class="ic-carrinho"
          />
          <h4 class="texto-menu-top">MEUS PEDIDOS</h4>
        </router-link>
        <div v-if="whatsappAtivo" class="div-botao-whatsapp">
          <button class="botao-whatsapp" type="" @click="abrirWhatsapp">
            <img
              class="img-whatsapp"
              :style="{ filter: corImagem }"
              src="../../assets/icons/ic_whatsapp_48.png"
              alt="Imagem do whatsApp"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- so barra de busca aqui  -->
    <div
      v-if="this.$store.state.mostrarBarraBusca"
      style="display: flex; flex-direction: row"
    >
      <div style="width: 20vw; height: 10%"></div>
      <div style="flex-grow: 1">
        <BarraDeBuscar />
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapState } from "vuex";
import BarraDeBuscar from "./BarraDeBuscar.vue";
import { CONSOLOGAR } from "../Controle/debug";
export default {
  name: "MenuTop",
  data() {
    return {
      numeroDeIensCarrinho: 0,
      precoTotalAteAgora: 0.0,
      logo: this.$store.state.logo,
      mesaOuCartao: this.$store.state.porCartao ? "COMANDA" : "MESA",
      numeroWhatsapp: this.$store.state.numeroWhatsapp,
      whatsappAtivo: this.$store.state.whatsappAtivo,
      corImagem:this.$store.state.corTexto === 'black' ? 'invert(0%)' : 'invert(100%)',
    };
  },
  computed: {
    ...mapState(["itensCarrinho"]),
    numeroMesa() {
      if (this.$store.state.porCartao) {
        return "";
      } else {
        return this.$store.state.mesa;
      }
    },
    podeVerConta() {
      if (this.$store.state.itensCarrinho.length > 0) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.calcularPrecoTotal();
  },
  methods: {
    abrirWhatsapp() {
      // const numero =41984359836;
      if(this.numeroWhatsapp){
        let numeroLimpo = this.numeroWhatsapp.replace(/[\s()-]/g, "");
        console.log(numeroLimpo);
        const mensagem =
          "Olá, tudo bem? Gostaria de mais informações sobre o Delivery Web.";
        const link = `https://wa.me/${numeroLimpo}?text=${encodeURIComponent(
          mensagem
        )}`;
        window.open(link, "blank");
      }
      else{console.log('Numero invalido!'+this.numeroWhatsapp)}
    },

    clicouCarrinho() {
      CONSOLOGAR(["clicou"]);
    },
    calcularPrecoTotal() {
      for (var i = 0; i < this.itensCarrinho.length; i++) {
        this.precoTotalAteAgora =
          this.precoTotalAteAgora +
          parseFloat(this.itensCarrinho[i].precoTotal);
      }
    },
    alertarVerConta() {
      if (this.podeVerConta) {
        Swal.fire({
          title: "Desculpe!",
          text: "Você não poderá ver a conta enquanto houver itens no carrinho de compras.",
        });
      }
    },
  },
  components: { BarraDeBuscar },
};
</script>

<style scoped>
.div-botao-whatsapp {
  position: absolute;
  right: 15px;
}
.botao-whatsapp {
  background: transparent;
  display: flex;
  padding: 0px;
}
.img-whatsapp {
  object-fit: contain;
  width: 12vw;
}

.swal2-title {
  color: red;
}
.swal-title {
  color: green;
}
.swal2-popup {
  font-size: 2.6rem !important;
}

.row {
  height: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  /* background: linear-gradient(to top, var(--cor1-escura), var(--cor1-clara)); */
  background: var(--gradiente-btn-conta);
  /* background: green; */
  color: white;
}

.img-container {
  width: 20vw;
  height: var(--altura-menu-padrao);
  background: var(--cor1-muito-escura)
}

.logo {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  max-width: 80%;
  max-height: 80%;
}

.ic-carrinho {
  height: 22px;
}

.preco {
  align-items: center;
  display: flex;
  flex-grow: 1;
  height: var(--altura-menu-padrao);
}

.icone-texto {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  color: var(--cor-texto);
  text-decoration: none;
  justify-content: center;
  margin-inline: auto;
  padding-inline: 15px;
}

.icone-texto > h4 {
  font-size: 12px;
  font-weight: 900;
}

.icone-texto img {
}

.icone-texto p {
  margin-left: 10px;
  font-size: 12px;
}

.menu-estatico-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.texto-menu-top{
  color: var(--cor-texto);
}
</style>
